const STATUS_MAP = {
  'I/P':            'pill-ip',
  'Needs Review':   'pill-nr',
  'Needs Revision': 'pill-revision',
  'Approved':       'pill-approved',
  'Backburner':     'pill-backburner',
  'Scripted':       'pill-scripted',
  'Filming':        'pill-filming',
  'Filmed':         'pill-filmed',
  'Editing':        'pill-editing',
  'Qual':           'pill-qual',
  'Posted':         'pill-posted',
  'Incomplete':     'pill-incomplete',
};

export default function StatusPill({ status }) {
  return (
    <span className={`pill ${STATUS_MAP[status] || 'pill-ip'}`}>
      {status}
    </span>
  );
}
